import React from "react";
import Headline from "~assets/js/components/Typography/Headline";
import i18next from "i18next";
import { Check } from "react-feather";
import Button from "~assets/js/components/Button";
import PropTypes from "prop-types";

export const BenefitsSection = () => (
    <div className="franchise-benefits-section">
        <div className="left"></div>
        <div className="right">
            <p className="heading-top">
                {i18next.t("franchise.benefits.topTitle")}
            </p>
            <Headline size={3} className="heading">
                {i18next.t("franchise.benefits.heading")}
            </Headline>
            <div className="points">
                <Point text={i18next.t("franchise.benefits.points.first")} />
                <Point text={i18next.t("franchise.benefits.points.second")} />
                <Point text={i18next.t("franchise.benefits.points.third")} />
                <Point text={i18next.t("franchise.benefits.points.fourth")} />
                <Point text={i18next.t("franchise.benefits.points.fifth")} />
            </div>
            <div className="franchise-benefits-section-button">
                <Button
                    href="/franchise-formular"
                    size="SM"
                    variant="primary"
                    label={i18next.t("franchise.banner.hero.cta")}
                />
            </div>
        </div>
    </div>
);

const Point = ({ text }) => {
    return (
        <div className="franchise-benefits-section__point">
            <div className="icon">
                <Check color="#00E940"></Check>
            </div>
            <p className="text">{text}</p>
        </div>
    );
};

Point.propTypes = {
    text: PropTypes.string,
};

export default BenefitsSection;
